'use strict';

/**
 * TokenRefresh — refresh transparente del JWT.
 *
 * Llama a POST /oauthrefresh/ con el refreshToken guardado y persiste el par nuevo
 * (el server rota el refresh: emite uno nuevo y borra el viejo).
 *
 * Singleton: si ya hay un refresh en vuelo, devuelve la MISMA promise, así N requests
 * concurrentes que reciben 401 disparan una sola llamada a /oauthrefresh/.
 * Espeja el patrón del cliente mobile (agenda-apps/packages/api).
 */
angular.module("ufcw")

.factory('TokenRefresh', ['$http', '$q', '$localstorage', 'EnvConfig', function($http, $q, $localstorage, EnvConfig) {
  var refreshing = null;

  return {
    refresh: function() {
      if (refreshing) {
        return refreshing;
      }
      var refreshToken = $localstorage.get('refreshToken');
      if (!refreshToken) {
        return $q.reject('no_refresh_token');
      }

      refreshing = $http.post(EnvConfig.URL_API + 'oauthrefresh/', { refresh_token: refreshToken })
        .then(function(res) {
          var data = res.data || {};
          if (!data.accessToken) {
            return $q.reject('refresh_failed');
          }
          $localstorage.set('token', data.accessToken);
          if (data.refreshToken) {
            $localstorage.set('refreshToken', data.refreshToken);
          }
          return data.accessToken;
        })
        ['finally'](function() {
          refreshing = null;
        });

      return refreshing;
    }
  };
}]);
